// apps/web/src/app/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClerkAuthService } from '../services/clerk-auth.service';

export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const clerkAuthService = inject(ClerkAuthService);

  if (!clerkAuthService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  return true;
};